import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <p>This is working :)</p>
    </div>
  );
}

export default App;
